import { useCallback } from 'react';
import { useQueryClient } from '@common-fe/common-fe';

import { QUERY_KEYS } from '@/modules/transaction/queries/useGetCards.query';
import { getTokenData } from '@/modules/user/hooks/useAuth';
import { useAuthStore } from '@/modules/user/stores';

const useHandleRefetchCards = () => {
  const queryClient = useQueryClient();
  const store = useAuthStore();
  const handleRefetch = useCallback(() => {
    const { role } = getTokenData();
    store.setUser({
      ...store.user,
      role,
    });
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.GET_CARDS_HOLDERS],
    });
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.GET_CARDS_PURSES],
    });
  }, [queryClient, store]);

  return handleRefetch;
};

export default useHandleRefetchCards;
